module.exports = __webpack_public_path__ + "static/img/recharge.266e1f91.png";